"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHATSAPP_HANDLED_REASONS = exports.WHATSAPP_INBOX_VIEWS = void 0;
exports.getWhatsappActionState = getWhatsappActionState;
exports.isWhatsappActiveSalesStage = isWhatsappActiveSalesStage;
const crm_stages_model_1 = require("./prompts/crm-stages.model");
exports.WHATSAPP_INBOX_VIEWS = ['needs_action', 'active_sales', 'all'];
exports.WHATSAPP_HANDLED_REASONS = ['spam', 'opt_out', 'wrong_number'];
function toMs(value) {
    if (value === undefined)
        return undefined;
    if (value instanceof Date)
        return value.getTime();
    if (typeof value === 'object')
        return value.seconds * 1000 + Math.floor((value.nanoseconds ?? 0) / 1_000_000);
    const ms = typeof value === 'number' ? value : Date.parse(value);
    return Number.isNaN(ms) ? undefined : ms;
}
function getWhatsappActionState(conversation) {
    const lastInboundAt = toMs(conversation.lastInboundAt);
    const lastMessageAt = toMs(conversation.lastMessageAt);
    const lastAcceptedReplyAt = Math.max(toMs(conversation.lastStaffReplyAt) ?? Number.NEGATIVE_INFINITY, toMs(conversation.lastAssistantReplyAt) ?? Number.NEGATIVE_INFINITY);
    const inboundIsTail = lastInboundAt !== undefined && (conversation.actionTrackingVersion === 1
        ? lastAcceptedReplyAt <= lastInboundAt
        : lastMessageAt === undefined || lastInboundAt >= lastMessageAt);
    const inboundMessageId = conversation.lastInboundMessageId
        ?? (inboundIsTail ? conversation.lastMessageId : undefined);
    return {
        needsAction: inboundIsTail
            && (!inboundMessageId || conversation.handledInboundMessageId !== inboundMessageId),
        ...(inboundMessageId ? { inboundMessageId } : {}),
    };
}
function isWhatsappActiveSalesStage(stage) {
    if (!stage)
        return false;
    if (stage.mainStageId === crm_stages_model_1.MainStageType.QUOTE)
        return stage.subStageId !== 'old_quotes';
    if (stage.mainStageId === crm_stages_model_1.MainStageType.SPECIAL_CASES)
        return stage.subStageId === 'interested';
    return stage.mainStageId === crm_stages_model_1.MainStageType.FOLLOW_UP && stage.subStageId === 'after_quote';
}
